import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  Button,
  Label,
} from "reactstrap";
import {
  CREATE_TRIVVY_MODAL_IMAGES,
  CUSTOM_QUESTION_INPUT_TYPES,
  MAX_OPTIONS_ARRAY,
  MIN_OPTIONS_ARRAY,
  WEB_GENERATE_ERROR_MESSAGE,
} from "../../data";
import Select from "react-select";
import QuizTextEditor from "../../../../components/QuizTextEditor/QuizTextEditor";
import { BiXCircle } from "react-icons/bi";
import { isMobile } from "../../../../utils/deviceInfo";
import RangeInput from "../../../../components/RangeInput/RangeInput";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import ReactTooltip from "react-tooltip";
import LibQuestionFormFields from "./LibQuestionFormFields";
import { toastContainer } from "../../../../utils/toast";

const question_count_options = Array(20)
  .fill()
  .map((_, index) => ({ label: index + 1, value: index + 1 }));

export default function LibraryQuestionGenerateModal({
  open,
  onClose,
  library,
  generateCall,
}) {
  const [selectedType, setSelectedType] = useState(null);
  const [questionData, setQuestionData] = useState({
    questionType: "MCQ",
    text: "",
    options: ["Option 1"],
    correctOption: "",
    linearNumericConfigs: { min: 1, max: 10 },
  });
  const [hoveredOption, setHoveredOption] = useState(null);

  const [aiQuestionsToGenerate, setAiQuestionsToGenerate] = useState(5);

  const handleGenerateQuestions = () => {
    const {
      questionType,
      text,
      options,
      correctOption,
      linearNumericConfigs,
    } = questionData;

    const payload = {
      question_text: text,
      options: options,
      questionType,
      answer: correctOption,
      linearNumericConfigs: linearNumericConfigs,
      libraryId: library._id,
      isGenerateFromAi: selectedType == 2,
      sourceUrl: library.s3Url,
      questionsCount: aiQuestionsToGenerate || 1,
    };

    generateCall(payload);
  };

  return (
    <Modal isOpen={open}>
      <ModalHeader toggle={onClose} className="trivia_modal_header_bg">
        Add questions
      </ModalHeader>
      <ModalBody className="p-4">
        {selectedType == null ? (
          <div className="my-3">
           
            <div
              className="trivvy-create-option-card ai-create"
              onClick={() => setSelectedType(2)}
            >
              <img
                src={CREATE_TRIVVY_MODAL_IMAGES.AI}
                className="trivvy-create-option-card-img"
              />
              <div className="trivvy-create-option-card-txt">
                {" "}
                <b>AI-generated </b>Question Bank from your source document that you can auto-schedule later.
              </div>
            </div>

            <div
              className="trivvy-create-option-card custom-create"
              onClick={() => setSelectedType(1)}
            >
              <img
                src={CREATE_TRIVVY_MODAL_IMAGES.CUSTOM}
                className="trivvy-create-option-card-img"
              />
              <div className="trivvy-create-option-card-txt">
                {" "}
                <b>Create a custom</b> Question Bank manually and auto-schedule as trivvys later.
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {selectedType == 2 ? (
          <div>
            <Label>Number of questions</Label>
            <Select
              options={question_count_options}
              value={aiQuestionsToGenerate}
              onChange={e => {
                if (e) {
                  setAiQuestionsToGenerate(e.value);
                } else {
                  setAiQuestionsToGenerate(null);
                }
              }}
              placeholder="Select number of questions..."
            />
          </div>
        ) : selectedType == 1 ? (
          <div>
            <div className="my-3 d-flex-align-center">
              <div>Question Type</div>
              <div
                style={{
                  flex: 1,
                  paddingLeft: "20px",
                }}
              >
                <Select
                  options={CUSTOM_QUESTION_INPUT_TYPES}
                  value={questionData.questionType}
                  onChange={e => {
                    if (e) {
                      if (e.value === "MCQ") {
                        setQuestionData({
                          ...questionData,
                          questionType: "MCQ",
                        });
                      } else {
                        setQuestionData({
                          ...questionData,
                          questionType: e.value,

                          options: [],
                          correctOption: "",
                        });
                      }
                    } else {
                      setQuestionData({
                        ...questionData,
                        questionType: null,
                      });
                    }
                  }}
                />
              </div>
            </div>

            <LibQuestionFormFields
              questionData={questionData}
              setQuestionData={setQuestionData}
            />
          </div>
        ) : (
          ""
        )}

        {selectedType != null && (
          <div className="mt-5">
            <Button
              className="float-right trivia-action-button-main"
              onClick={() => handleGenerateQuestions()}
              style={{
                height: "37px",
              }}
              disabled={selectedType === 1 && !questionData.text.length}
            >
              Add Questions
            </Button>
            <Button
              className="float-right mr-2"
              onClick={() => {
                setSelectedType(null);
              }}
            >
              Back
            </Button>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
}
